/* eslint-disable no-undef */
/* eslint-disable max-len */
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useHistory, useParams, useQueryParams, useLocation } from 'react-router-dom';
import ShowToast from '../components/ShowToast';
import {
  useProgramDateCheckStore,
  useProgramStore,
  useSetTZProgram,
  useTokenStore,
  useUserStore,
  useGameConfigSetup,
  useGameConfigCalamity,
  useCreditStore,
  useFacilitatorStore,
  useUserTransactions,
} from '../store';
import axiosClient from '../utils/axiosClient';

const storeUserToken = (res) => {
  useTokenStore.getState().setTokens({
    accessToken: res.data.accessToken,
    expiresIn: res.data.expiresIn,
  });
  useUserStore.getState().setUser(res.data.user);
};

export const useUserLogin = () => {
  return useMutation((data) => axiosClient().post('/login', data), {
    onSuccess: (res) => {
      localStorage.setItem('userId', res.data.user.id);
      storeUserToken(res);
    },
  });
};

export const useUserRegister = () => {
  return useMutation((data) => axiosClient().post('/register', data), {
    onSuccess: (res) => {
      storeUserToken(res);
      localStorage.setItem('userId', res.data.user.id);
    },
  });
};

export const useSignout = (logout) => {
  const { clearTokens } = useTokenStore();
  const { clearUser } = useUserStore();
  const history = useHistory();
  useEffect(() => {
    if (logout) {
      clearTokens();
      clearUser();
      // localStorage.removeItem('isCertified');
      history.push('/');
    }
  }, [clearTokens, clearUser, history, logout]);
};

export const useUserInfo = () => {
  const hasToken = useTokenStore((s) => !!s.accessToken);

  const { isError } = useQuery('user-info', () => axiosClient().get('/userInfo'), {
    onSuccess: (res) => useUserStore.getState().setUser(res.data.user),
    enabled: hasToken,
  });

  useSignout(isError);
};

export const useUpdateUserProfile = () => {
  const fromProgram = useSetTZProgram((s) => s.from_program);
  const setTz = useSetTZProgram((s) => s.setTz);
  const history = useHistory();

  const { search } = useLocation();
  const programpage = new URLSearchParams(search).get('programpage');

  return useMutation((data) => axiosClient().post('/updateUserProfile', data), {
    onSuccess: (res) => {
      useUserStore.getState().setUser(res.data.user);
      ShowToast(res.data.message, 'success');
      if (fromProgram) {
        if (programpage) {
          history.push(`/schedule/add/${programpage}`);
          setTz(false);
        } else {
          history.push('/my-programs');
          setTz(false);
        }
      }
    },
  });
};

export const useUpdateProfilePic = () => {
  return useMutation((data) => axiosClient().post('/updateProfilePic', data), {
    onSuccess: (res) => {
      useUserStore.getState().setUser(res.data.user);
      ShowToast(res.data.message, 'success');
    },
  });
};

export const useUserSearch = (data, setUsers) => {
  const [rq, setRq] = useState();
  const queryClient = useQueryClient();

  const query = useQuery(
    ['user-search', rq],
    () => axiosClient().get(`/searchUsers?search=${rq}`),
    {
      onSuccess: (res) => {
        setUsers(res.data.result);
      },
      cacheTime: 0,
      enabled: !!rq,
    }
  );

  useEffect(() => {
    if (data && data.length >= 3) {
      setRq(data);
    }
  }, [data, query, queryClient, rq]);

  return query;
};

export const useAddProgram = () => {
  const history = useHistory();
  return useMutation((data) => axiosClient().post('/addProgram', data), {
    onSuccess: (res) => {
      ShowToast(res.data.message, 'success');
      history.push('/complete');
    },
    onError: (err) => {
      ShowToast("You don't have sufficient credits. Please buy credits", 'error');
    },
  });
};

export const useUpdateProgram = () => {
  const history = useHistory();
  return useMutation(
    (data) => axiosClient().post('/updateProgram', data),

    {
      onSuccess: (res) => {
        ShowToast(res.data.message, 'success');
        history.push('/my-programs');
      },
      onError: (err) => {
        ShowToast('Error while updating', 'error');
      },
    }
  );
};

export const useCheckProgramDate = () => {
  const history = useHistory();

  return useMutation((data) => axiosClient().post('/checkProgramDate', data), {
    onSuccess: (res) => {
      useProgramDateCheckStore.getState().setCheck(res.data.result);
      if (res.data.result) {
        ShowToast(
          'You cannot create another program in the same timeframe as another program you are facilitating..',
          'error'
        );
      } else {
        history.push('/confirm');
      }
    },
    cacheTime: 0,
  });
};

export const useUpdateFacilitator = () => {
  const history = useHistory();
  return useMutation((data) => axiosClient().post('/updateProgramFacilitator', data), {
    onSuccess: (res) => {
      ShowToast(res.data.message, 'success');
      history.push('/my-programs');
    },
    onError: (err) => {
      ShowToast('Error while updating facilitator', 'error');
    },
  });
};

// export const updateGameConfigSetup = () => {
//   return useMutation(
//     (data) => axiosClient().post('https://prodapi.evivve.com:3000/api/setup', data),
//     {
//       onSuccess: (res) => {
//         ShowToast('Game config setup updated', 'Success');
//       },
//       cacheTime: 0,
//     }
//   );
// };

export const useGetProgramsList = () => {
  return useQuery('programs-list', () => axiosClient().get(`/getProgramsList`), {
    onSuccess: (res) => {
      useProgramStore.getState().setProgramsList(res.data.result);
      useProgramStore.getState().setAllProgramList(res.data.allPrograms);
    },
    cacheTime: 0,
  });
};

export const useGetGameConfigSetup = () => {
  const { id } = useUserStore.getState().user;
  return useQuery(
    'game-config-setup',
    () =>
      axiosClient().get(
        'https://prodapi.evivve.com:3000/api/setup?user_id=02126234-7a72-42b2-8144-538bf8fdb309'
      ),
    {
      onSuccess: (res) => {
        useGameConfigSetup.getState().setSetupList(res.data.data);
      },
      cacheTime: 0,
    }
  );
};

export const useGetGameConfigCalamity = () => {
  const { id } = useUserStore.getState().user;
  return useQuery(
    'game-config-calamity',
    () =>
      axiosClient().get(
        'https://prodapi.evivve.com:3000/api/calamity?user_id=02126234-7a72-42b2-8144-538bf8fdb309'
      ),
    {
      onSuccess: (res) => {
        useGameConfigCalamity.getState().setCalamityList(res.data.data);
      },
      cacheTime: 0,
    }
  );
};

export const useGetGameConfigSetting = () => {
  // const { id } = useUserStore.getState().user;
  const id = localStorage.getItem('userId');
  return useQuery(
    'game-config-calamity',
    () => axiosClient().get(`/getUserCalamitySetupData/${id}`),
    {
      onSuccess: (res) => {
        useGameConfigCalamity.getState().setCalamityList(res.data.data.calamity);
        useGameConfigSetup.getState().setSetupList(res.data.data.setup);
      },
      cacheTime: 0,
    }
  );
};

export const useGetAllFacilitator = () => {
  return useQuery('get-facilitator', () => axiosClient().get('/getAllfacilitators'), {
    onSuccess: (res) => {
      useFacilitatorStore.getState().setFacilitatorsList(res.data.facilitators);
    },
  });
};

export const useGetUserTransactions = () => {
  return useQuery('get-transactions', () => axiosClient().get('/getUserTransactions'), {
    onSuccess: (res) => {
      useUserTransactions.getState().setTransactionList(res.data.transactions);
    },
    enabled: false,
  });
};

export const useGetCreditsByUserId = () => {
  // call api 2 times because useQuery not updating token imedietly
  axiosClient()
    .get('/getUserCredits')
    .then((res) => {
      useCreditStore.getState().setCredits({ half: res.data.halfNet, full: res.data.fullNet });
    });
  return useQuery('get-credits', () => axiosClient().get('/getUserCredits'), {
    onSuccess: (res) => {
      useCreditStore.getState().setCredits({ half: res.data.halfNet, full: res.data.fullNet });
    },
    cacheTime: 0,
    enabled: true,
  });
};

// export const useResetConfig = () => {
//   const { id } = useUserStore.getState().user;
//   return useQuery('reset-config', () =>
//     axiosClient().post(
//       'https://prodapi.evivve.com:3000/api/otherusers/resetgameconfig',
//       { id },
//       {
//         onSuccess: (res) => {
//           console.log('game config reset');
//         },
//         cacheTime: 0,
//       }
//     )
//   );
// };

// export const useGetGameConfigCalamity = () => {
//   console.log('useGetGameConfigCalamity called');
//   const { id } = useUserStore.getState().user;
//   return useQuery(
//     'game-config-calamity',
//     () =>
//       axiosClient().get(
//         'https://prodapi.evivve.com:3000/api/calamity?user_id=ee155554-9c06-4798-9808-ee5629f7fc10'
//       ),
//     {
//       onSuccess: (res) => {
//         console.log('useGetGameConfigCalamity', res.data);
//       },
//       cacheTime: 0,
//     }
//   );
// };

const useUpdateRazorResponse = () => {
  return useMutation((data) => axiosClient().post('/razorResponse', data), {
    onSuccess: (res) => {},
    cacheTime: 0,
  });
};

export const useTransferCredits = () => {
  return useMutation(
    (data) => {
      axiosClient().post('/transferCredits', data);
    },
    {
      onSuccess: (res) => {
        ShowToast('Credits Successfully Transfered!', 'success');
        useCreditStore.getState().setCredits({ half: res.data.halfNet, full: res.data.fullNet });
      },
    }
  );
};

export const useBuyCredits = () => {
  const update = useUpdateRazorResponse();

  return useMutation((data) => axiosClient().post('/buyCredits', data), {
    onSuccess: (res) => {
      const options = {
        key: 'rzp_test_JxY97C56EEsn29',
        amount: res.data.order.amount,
        currency: res.data.order.currency,
        order_id: res.data.order.id,
        handler(response) {
          const data = {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
          };
          update.mutate(data);
        },
        prefill: {
          name: `${useUserStore.getState().user.first_name} ${
            useUserStore.getState().user.last_name
          }`,
          email: useUserStore.getState().user.email,
        },
        theme: {
          color: '#453054',
        },
      };

      const rzp1 = new Razorpay(options);
      rzp1.open();
    },
    cacheTime: 0,
  });
};
